/* eslint-disable @typescript-eslint/no-explicit-any */

import { createExercise } from '@datacamp/campus-integration';
import { constants, utils } from '@datacamp/pure-multiple-choice-exercise-core';
import { applyMiddleware, compose, createStore } from 'redux';
import reduxThunk from 'redux-thunk';
import setExerciseEntity from './actions/actionCreators/exerciseEntityUpdated';
import Shell from './components/Shell';
import config, { USED_AS_SPA } from './config';
import { sentry } from './lib/sentry';
import de from './locales/de-DE/translation.json';
import en from './locales/en/translation.json';
import es from './locales/es/translation.json';
import fr from './locales/fr-FR/translation.json';
import it from './locales/it-IT/translation.json';
import pt from './locales/pt-BR/translation.json';
import tr from './locales/tr-TR/translation.json';
import reducers from './reducers';
function isDefinedObject(obj) {
  return typeof obj === 'object';
}
function hasExt(obj) {
  return !!obj;
}
const win = global;
const composeEnhancers = USED_AS_SPA && isDefinedObject(win) && hasExt(win.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ? win.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;
const store = createStore(reducers, composeEnhancers(applyMiddleware(reduxThunk)));
const App = createExercise({
  config,
  requireAuthenticatedUser: false,
  sentryInstance: sentry,
  setExerciseEntity,
  store,
  translations: {
    de: {
      translation: de
    },
    en: {
      translation: en
    },
    es: {
      translation: es
    },
    fr: {
      translation: fr
    },
    it: {
      translation: it
    },
    pt: {
      translation: pt
    },
    tr: {
      translation: tr
    }
  },
  type: constants.exercises.PURE_MULTIPLE_CHOICE_EXERCISE,
  validate: utils.exerciseTypeVersionAdapter
})(Shell);
export default App;